import Vue from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import "./assets/css/tailwind.css";
import "./assets/css/common.css";
import upperFirst from "lodash/upperFirst";
import camelCase from "lodash/camelCase";
import numeral from "numeral";
import numFormat from "vue-filter-number-format";

import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faCog,
  faDollarSign,
  faFileInvoice,
  faPaperclip,
  faTv,
  faLayerGroup,
  faTags,
  faObjectGroup,
  faUser,
  faWater,
  faHatCowboy,
  faCodeBranch,
  faTrash,
  faTimesCircle,
  faSpinner,
  faCloudUploadAlt,
  faPauseCircle,
  faPlay,
  faPencilAlt,
  faPlus,
  faSwimmer,
  faShoppingCart,
  faCartPlus,
  faSearch,
  faArrowLeft,
  faArrowRight,
  faMinusCircle,
  faHome,
  faChevronRight,
  faChevronDown,
  faEye,
  faEnvelope,
  faRedo,
  faWindowMinimize,
  faCompress,
  faExpand,
  faDownload,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import "./plugins/element.js";
library.add(
  faCog,
  faDollarSign,
  faFileInvoice,
  faPaperclip,
  faTv,
  faLayerGroup,
  faTags,
  faObjectGroup,
  faUser,
  faWater,
  faHatCowboy,
  faCodeBranch,
  faTrash,
  faTimesCircle,
  faSpinner,
  faCloudUploadAlt,
  faPauseCircle,
  faPlay,
  faPencilAlt,
  faPlus,
  faSwimmer,
  faCartPlus,
  faShoppingCart,
  faSearch,
  faArrowLeft,
  faArrowRight,
  faMinusCircle,
  faHome,
  faChevronRight,
  faChevronDown,
  faEye,
  faEnvelope,
  faRedo,
  faWindowMinimize,
  faCompress,
  faExpand,
  faDownload
);
Vue.component("font-awesome-icon", FontAwesomeIcon);

import Bugsnag from "@bugsnag/js";
import BugsnagPluginVue from "@bugsnag/plugin-vue";
Bugsnag.start({
  apiKey: "df7986f3af4319b894f6138c55da6ebe",
  plugins: [new BugsnagPluginVue()],
});

let longpress = require("vue-long-press-directive");
Vue.use(longpress);

const requireComponent = require.context(
  "./components",
  true,
  /Base[A-Z]\w+\.(vue|js)$/
);
requireComponent.keys().forEach((fileName) => {
  const componentConfig = requireComponent(fileName);
  const componentName = upperFirst(
    camelCase(
      fileName
        .split("/")
        .pop()
        .replace(/\.\w+$/, "")
    )
  );
  Vue.component(componentName, componentConfig.default || componentConfig);
});

Vue.filter("capitalize", function (value) {
  if (!value) return "";
  value = value.toString();
  return value.charAt(0).toUpperCase() + value.slice(1);
});
Vue.filter("numberFormat", numFormat(numeral));

Vue.config.productionTip = false;

new Vue({
  store,
  router,
  render: (h) => h(App),
}).$mount("#app");
